import { IClient, IClientFilter, IClientForm, IClients } from '@/types';
import { BaseService, endpoints, http } from './base';

export class ClientService extends BaseService<IClient> {
  constructor() {
    super(endpoints.clients.default);
  }

  public async getDetail(id: string): Promise<IClient> {
    const { data: res } = await http.get(this.url + '/' + id);
    return res;
  }

  public async getAll(params?: IClientFilter): Promise<IClients> {
    const { data: res } = await http.get(this.url, { params });
    return res;
  }

  public async storeData(body: IClientForm): Promise<IClient> {
    const { data } = await http.post(this.url, body);
    return data;
  }

  public async updateData(id: string, body: IClientForm): Promise<IClient> {
    const { data: res } = await http.patch(this.url + '/' + id, body);
    return res;
  }

  public async getClientsByPlan(planId: string): Promise<any> {
    const { data: res } = await http.get(`/clients/plans/${planId}`);
    return res;
  }
}
